import { render, staticRenderFns } from "./SignupDialog.vue?vue&type=template&id=44668810&scoped=true"
import script from "./SignupDialog.vue?vue&type=script&lang=js"
export * from "./SignupDialog.vue?vue&type=script&lang=js"
import style0 from "./SignupDialog.vue?vue&type=style&index=0&id=44668810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44668810",
  null
  
)

export default component.exports